module.exports = __webpack_public_path__ + "img/simple-vs-advanced-search.4ddf0700.png";